// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__aKU2Q","secondary":"Text_secondary__hPOOv","strong":"Text_strong__gWjFK","italic":"Text_italic__1G_nJ"};